export default __webpack_public_path__ + "static/media/article09.346ad3db.md";